import React, { useEffect, useState } from "react";
import ReactModal from 'react-modal';

import axios from "axios";

import Validate from '../../../helpers/validate';
import authHeader from '../../../services/auth-header';
import { TextControl, SelectControl } from '../Controls';

function EditTransactionModal(props) {

    const [description, setDescription] = useState('');
    const [type, setType] = useState('');
    const [errorMessage, setErrorMessage] = useState({});

    useEffect(() => {
        if (props.isOpen) {
            setType(props.currentTransaction.conceptType == 'DEBIT' ? 1 : 2);
            setDescription(props.currentTransaction.description);
        }
    }, [props.isOpen])

    async function handleSubmit() {
        const validate = new Validate();
        const message = {};
        message.description = validate.init(description, {
            maxLength: {
                value: 254,
                message: 'The maximum length possible is 254 characters'
            },
            minLength: {
                value: 1,
                message: 'The minimum length possible is 1 character'
            }
        }).getHTML();
        setErrorMessage(message);

        if (validate.status) {
            await axios.put(process.env.REACT_APP_API_URL + `api/admin/updateTransaction/${props.currentTransaction.tcId}`, {
                description, type
            }, {
                headers: authHeader()
            });
            props.updateTable();
            props.onClose();
        }
    }

    function handleFocus(event) {
        const element = event.target.id,
            messages = errorMessage;
        messages[element] = null;
        setErrorMessage(messages);
    }

    function clearControls() {
        setType('');
        setDescription('');
    }

    return (
        <ReactModal isOpen={props.isOpen} style={{ overlay: { zIndex: '999' } }}>
            <div className="container">
                <div className="row">
                    <div className="col s11 left hide-on-small-only" style={{ fontVariant: 'small-caps', fontFamily: 'Raleway', fontSize: '2rem' }}>
                        Edit Transaction
                    </div>
                    <div className="col s1 right">
                        <a onClick={() => {
                            clearControls();
                            props.onClose();
                        }} className="btn-floating waves-effect waves-light black white-text"><i className="material-icons">close</i></a>
                    </div>
                </div>
                <hr />
                <CustomRow>
                    <div className="input-field col s8">
                        <TextControl id="description" type="description" value={description} inputEventHandler={setDescription} focusEventHandler={handleFocus} maxlength="254" />
                        <label className="active" htmlFor="description">Description</label>
                        <span data-assigned="description" className="helper-text red-text text-darken-1">{errorMessage.description}</span>
                    </div>
                </CustomRow>
                <CustomRow>
                    <div className="input-field col s8" style={{ fontSize: '0.8em' }}>Type</div>
                </CustomRow>
                <CustomRow>
                    <div className="input-field col s8">
                        <SelectControl value={type} inputEventHandler={setType} focusEventHandler={handleFocus} id="type" type="type">
                            <option value="1" selected>Debit</option>
                            <option value="2" selected>Credit</option>
                        </SelectControl>
                        <span data-assigned="type" className="helper-text red-text text-darken-1">{errorMessage.type}</span>
                    </div>
                </CustomRow>
                <CustomRow>
                    <div className="input-field col s8">
                        <a onClick={handleSubmit} style={{ width: '100%', fontFamily: 'Raleway', fontSize: '1rem', backgroundColor: 'black', marginTop: '30px' }} className="waves-effect waves-light btn z-depth-0 white-text">SAVE & CLOSE</a>
                    </div>
                </CustomRow>
            </div>
        </ReactModal>
    );
}

function CustomRow(props) {
    return (
        <div className={`row ${props.className}`}>
            <div className="col s2"></div>
            {props.children}
            <div className="col s2"></div>
        </div>
    );
}

export default EditTransactionModal;